import authService from './auth-service/authService';
import shopAuthService from './shop-auth-service/shopAuthService';
import profileService from './profile-service/profileService';
import userService from './user-service/userService';
import permissionService from './permission-service/permissionService';

export default {
  authService,
  shopAuthService,
  profileService,
  userService,
  permissionService,
};
